import React from 'react'

import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

import { ExpandMore } from '@mxenabled/mx-icons'

export type SelectOption = {
  id: number
  label: string
}

interface SelectProps extends Omit<React.ComponentProps<typeof TextField>, 'onChange'> {
  label: string
  onChange: (value: number) => void
  options: SelectOption[]
  // Allow '' for the no-selection state. MUI Select warns "out-of-range value"
  // when a numeric sentinel (e.g. 0) isn't among the options; '' is MUI's
  // canonical empty value.
  value: number | ''
}

export const Select = ({ label, onChange, options, value, ...props }: SelectProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(Number(event.target.value))
  }

  return (
    <TextField
      defaultValue=""
      label={label}
      onChange={handleChange}
      select={true}
      slotProps={{
        inputLabel: { shrink: true },
        select: {
          IconComponent: (props: React.ComponentProps<typeof ExpandMore>) => (
            <ExpandMore size={20} sx={{ mr: 4 }} {...props} />
          ),
        },
      }}
      value={value}
      variant="outlined"
      {...props}
    >
      {options.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
